const PREVIEWING_CLASS = 'previewing';
const ROW_SELECTOR = 'tr.preview-row';
const SWAP_SELECTOR = '.preview-swap';
const PANEL_SELECTOR = '.side-panel.row-preview';
const NON_PREVIEW_SELECTOR = 'a, button, input, select, label, .no-row-preview';

const highlight = (row) => {
    document
        .querySelectorAll(`${ROW_SELECTOR}.${PREVIEWING_CLASS}`)
        .forEach((previewing) => previewing.classList.remove(PREVIEWING_CLASS));

    row?.classList.add(PREVIEWING_CLASS);
};

const previewRows = (row) => [...(row.closest('tbody')?.querySelectorAll(ROW_SELECTOR) ?? [])];

const adjacentRow = (row, direction) => {
    const rows = previewRows(row);
    const index = rows.indexOf(row);

    if (index === -1) {
        return null;
    }

    return direction === 'next' ? rows[index + 1] ?? null : rows[index - 1] ?? null;
};

const swapControlOf = (row) => row?.querySelector(SWAP_SELECTOR) ?? null;

const hasTextSelection = () => Boolean(window.getSelection && String(window.getSelection()));

export const triggerRowPreview = (target) => {
    const row = target.closest(ROW_SELECTOR);

    if (!row || target.closest(NON_PREVIEW_SELECTOR) || hasTextSelection()) {
        return false;
    }

    highlight(row);
    row.dispatchEvent(new CustomEvent('preview'));

    return true;
};

export const navigatePreview = (direction) => {
    const current = document.querySelector(`${ROW_SELECTOR}.${PREVIEWING_CLASS}`);

    if (!current) {
        return;
    }

    const neighbor = adjacentRow(current, direction);
    const swapControl = swapControlOf(neighbor);

    if (!swapControl) {
        return;
    }

    highlight(neighbor);
    document.querySelector(PANEL_SELECTOR).dataset.previewDirection = direction;
    swapControl.dispatchEvent(new CustomEvent('previewswap'));
};

export const clearPreviewHighlight = () => highlight(null);

export const syncPreviewNav = () => {
    const panel = document.querySelector(PANEL_SELECTOR);

    if (!panel) {
        return;
    }

    const current = document.querySelector(`${ROW_SELECTOR}.${PREVIEWING_CLASS}`);

    panel
        .querySelectorAll('[data-preview-nav]')
        .forEach((button) => {
            button.disabled = !current || !swapControlOf(adjacentRow(current, button.dataset.previewNav));
        });
};
